export const getLocalAuthConfig = () => {
  const localAuthority = 'https://spafaxappsdevb2c.b2clogin.com/spafaxappsdevb2c.onmicrosoft.com';
  const localAuthConfig = {
    clientId: '34e17f9f-e3e3-4795-a72a-f92718e1925b',
    authority: "".concat(localAuthority, "/B2C_1_SIGNUPIN2"),
    knownAuthorities: ['spafaxappsdevb2c.b2clogin.com'],
    passwordResetAuthority: "".concat(localAuthority, "/B2C_1_PWDRESET"),
    graphScope: 'https://graph.microsoft.net/.default',
    clientCredentialsFlowScope: 'https://spafaxappsdevb2c.onmicrosoft.com/afe2202a-7248-4671-96ef-be64ffe3bf83/buzz_app',
    buzzAuthEndpoint: 'buzzauthdevelop.azurewebsites.net'
  };
  return localAuthConfig;
};